import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgInstagram = (props: SVGProps) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 21" fill="none" {...props}>
      <path
        d="M10.5 2.296c2.675 0 2.993.01 4.05.059 2.715.123 3.983 1.412 4.107 4.107.049 1.056.058 1.374.058 4.05 0 2.675-.01 2.992-.058 4.048-.124 2.693-1.39 3.984-4.107 4.107-1.057.049-1.373.059-4.05.059-2.675 0-2.993-.01-4.049-.059-2.722-.124-3.984-1.418-4.107-4.108-.049-1.056-.059-1.373-.059-4.049 0-2.675.011-2.992.059-4.049.124-2.694 1.39-3.983 4.107-4.107 1.057-.048 1.374-.058 4.049-.058zm0-1.806c-2.721 0-3.062.012-4.13.06C2.73.717.707 2.736.54 6.38.493 7.449.48 7.789.48 10.51c0 2.722.012 3.063.06 4.132.167 3.639 2.186 5.661 5.828 5.828 1.07.049 1.41.06 4.132.06 2.721 0 3.063-.012 4.132-.06 3.635-.167 5.662-2.186 5.827-5.828.05-1.069.061-1.41.061-4.132 0-2.721-.012-3.062-.06-4.13C20.296 2.743 18.275.717 14.632.55c-1.07-.05-1.41-.06-4.132-.06zm0 4.875a5.145 5.145 0 100 10.29 5.145 5.145 0 000-10.29zm0 8.485a3.34 3.34 0 110-6.679 3.34 3.34 0 010 6.68zm5.349-9.89a1.203 1.203 0 100 2.405 1.203 1.203 0 000-2.405z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgInstagram;
